import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { components } from 'react-select';
export default function DSelectOptionEmoji(_a) {
    var { children, data } = _a, props = __rest(_a, ["children", "data"]);
    return (_jsxs(components.Option, Object.assign({ className: classNames({
            'd-select__option--has-icon': true,
        }), data: data }, props, { children: [_jsx("span", { children: data.emoji }), _jsx("span", { children: children })] })));
}
//# sourceMappingURL=DSelectOptionEmoji.js.map